import Point from './point';

export default class ForecastPoint extends Point {
  constructor() {
    super();
    this.parameters = [];
  }
}